import { WidgetConfigWithHideableToolbar } from 'widgets/WidgetToolbarShowHidePanel/WidgetConfigWithHideableToolbar';
import { TilesOrientation } from 'widgets/tiles/store/config/CapsuleContainerWidgetConfigState';
import { WidgetType } from 'widgets/WidgetType';
import { SortDirection } from '@instinet-analytics/core-lib';
import { TopicType } from 'widgets/myPortfolioCapsules/topics/TopicType';
import { WidgetConfigWithTabTitle } from 'widgets/tabTitle/WidgetConfigWithTabTitle';
import { AggregationKey } from 'widgets/myPortfolioCapsules/store/data/MyPortfolioCapsulesDataState.ts';

export interface MyPortfolioCapsulesWidgetConfigState
    extends WidgetConfigWithHideableToolbar,
        WidgetConfigWithTabTitle {
    orientation: TilesOrientation;
    numberToShow: number;
    capsuleType?: WidgetType;
    topic?: TopicType;
    sort: SortDirection;
    absoluteValues: boolean;
    showTitleCapsule: boolean;
    aggregationKey: AggregationKey;
}

export const initialMyPortfolioCapsulesConfigState: MyPortfolioCapsulesWidgetConfigState =
    {
        orientation: 'column',
        hideToolbar: true,
        numberToShow: 5,
        sort: SortDirection.DESCENDING,
        absoluteValues: false,
        showTitleCapsule: true,
        aggregationKey: 'allValid',
    };
